import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod/v4";

export const getBalanceTransactionCount = {
  name: "getBalanceTransactionCount" as const,
  input: AdvancedFilterInputSchema,
  output: z.object({ total: z.number() }),
};
